import { useContext } from "react";

import { FormType } from "@simplyk/common";

import { useFormV2Context } from "../../../../contexts/FormV2Context";

import { useAuctionFirstStepSubmit } from "./useAuctionFirstStepSubmit";

import { HeartsAnimationContext } from "@/canvas/features/FormV2/contexts/heartsAnimationContext";
import { useEnterKeyListener } from "@/canvas/features/FormV2/hooks/useEnterKeyListener";
import { useTranslate } from "@/common/hooks/useTranslate";
import { HeartsFormButton } from "@/forms-design-system/HeartsFormButton";
import { ArrowRight } from "@/icons/outlined";

export const AuctionCheckoutFooter = () => {
  const { t } = useTranslate();
  const { currentStep } = useFormV2Context(FormType.Ticketing);
  const { onFirstStepSubmit, canSubmitFirstStep } = useAuctionFirstStepSubmit();
  const { shouldDisplayHeartsAnimation, animationKey } = useContext(HeartsAnimationContext);

  useEnterKeyListener(onFirstStepSubmit, currentStep === "selection");

  return (
    <HeartsFormButton
      type="submit"
      endIcon={<ArrowRight />}
      onClick={onFirstStepSubmit}
      disabled={!canSubmitFirstStep}
      data-test="form-v2-step1-submit-button"
      animated={shouldDisplayHeartsAnimation}
      animationKey={animationKey}
      autoplay
      sx={(theme) => ({
        boxShadow: theme.shadows[2],
      })}
    >
      {t("donationForm", "continue")}
    </HeartsFormButton>
  );
};
